import { common, createSerializeWire, crypto, utils, } from '@neo-one/client-common';
import { BaseState } from './BaseState';
import { HasDynamicInvoke, HasPayable, HasStorage } from './ContractPropertyStateModel';
export class ContractModel extends BaseState {
    constructor({ version, script, parameterList, returnType, name, codeVersion, author, email, description, contractProperties, }) {
        super({ version });
        this.serializeWire = createSerializeWire(this.serializeWireBase.bind(this));
        this.hashInternal = utils.lazy(() => crypto.toScriptHash(this.script));
        this.hashHexInternal = utils.lazy(() => common.uInt160ToHex(this.hash));
        this.script = script;
        this.parameterList = parameterList;
        this.returnType = returnType;
        this.name = name;
        this.codeVersion = codeVersion;
        this.author = author;
        this.email = email;
        this.description = description;
        this.contractProperties = contractProperties;
        this.hasStorage = HasStorage.has(this.contractProperties);
        this.hasDynamicInvoke = HasDynamicInvoke.has(this.contractProperties);
        this.payable = HasPayable.has(this.contractProperties);
    }
    get hash() {
        return this.hashInternal();
    }
    get hashHex() {
        return this.hashHexInternal();
    }
    serializeWireBase(writer) {
        serializeContractWireBase({ writer, contract: this });
    }
}
export const serializeContractWireBase = ({ writer, contract, publishVersion, }) => {
    writer.writeVarBytesLE(contract.script);
    writer.writeVarBytesLE(Buffer.from(contract.parameterList));
    writer.writeUInt8(contract.returnType);
    if (publishVersion === undefined || publishVersion >= 1) {
        writer.writeUInt8(contract.contractProperties);
    }
    writer.writeVarString(contract.name);
    writer.writeVarString(contract.codeVersion);
    writer.writeVarString(contract.author);
    writer.writeVarString(contract.email);
    writer.writeVarString(contract.description);
};

//# sourceMappingURL=ContractModel.js.map
